<template>
    <dialog-component @dialogClose="d => d()" :dialog="dialog">
        <div slot="content" :class="shit$(`px:50px; pt:25px;`)">
            <template v-if="(popDialogData.describe instanceof Array)">
                <template v-for="(o, i) in popDialogData.describe">
                    <p :key="i" :class="shit$(`c:#fff; font-w:500; font:14px; letter-s:1px; lh:22px;`)">
                        {{ popDialogData.hsName ? replaceStrT(o, popDialogData.hsName, strSliceStarAndEndT(clickTarget.name$, 11, 7)) : o }}
                    </p>
                </template>
            </template>
            <template v-else>
                <p :class="shit$(`c:#fff; font-w:500; font:14px; letter-s:1px; lh:22px;`)">
                    {{ popDialogData.describe.hasName ? replaceStrT(popDialogData.describe, popDialogData.describe.hasName, strSliceStarAndEndT(clickTarget.name$, 11, 7)) : popDialogData.describe }}
                </p>
            </template>
        </div>
        <div slot="footer" :class="[shit$(`font:16px; letter-s:0.48px; pt:25px;`), shit$(`dis:f; align-i:c; justify-c:sb; px:30px;`),]">
            <section @click="() => $emit('back-switch', !dialog.isShow)" :class="[shit$(`bgc:#727272; cursor:p; c:#fff;`), this.assembleCommonBtnShit()]">{{this.$t( "code-lab/component/file-management/popDialog.vue_0" ) }}</section>
            <section @click="() => $emit('confirm-back')" :class="[shit$(`bgc:rgba(31, 31, 31, 0.5);`), this.assembleCommonBtnShit(), this.btnSelectedShit()]">{{this.$t( "code-lab/component/file-management/popDialog.vue_1" ) }}</section>
        </div>
    </dialog-component>
</template>

<script>
import DialogComponent from "@/code-lab/view/organization/s-dialog.vue";
import ToolMix from '@/code-lab/component/file-management/mixins/tool-mix.js'
import { store as fileCrudStore } from '@/code-lab/component/file-management/observable/fileCrudMapOber.js'
import { mapState } from 'vuex';
export default {
    mixins: [ ToolMix ],
    props: {
        data: Object
    },
    components: {
        DialogComponent
    },
    computed: {
        ...mapState(['currentVersion'])
    },
    data () {
        return {
            dialog: {
                showClose: false,
                width: "400px",
                isShow: true,
                isFooter: true,
                title: this.$t( "code-lab/component/file-management/popDialog.vue_2" ),
                class: "dialogOfManagecustomClass dialogOfManagecustomClassCrud",
                closeOnEscape: false,
                closeOnModal: false
            },
            popDialogData: {},
            clickTarget: {},
        }
    },
    watch: {
        data: {
            immediate: true,
            handler (newVal) {
                const mpKey = { 'false/true': 'private2Shared', 'true/false': 'shared2Private', 'true/true': 'shared2Shared' }
                const { clickTarget, data, dialog } = newVal
                const targetFileType = data.target[0].type$
                const targetFolderIsShared = !this.isTypeOfFileT(clickTarget, 'private');
                const isShared = !targetFolderIsShared || data.target.every(item => !this.isTypeOfFileT(item, "private"));
                const mpKeyOfKey = isShared + '/' + targetFolderIsShared
                const sharedPopOfKey = mpKey[mpKeyOfKey]
                console.log(sharedPopOfKey);
                const resData = fileCrudStore[this.currentVersion].sharedPop[sharedPopOfKey][targetFileType]
                Object.assign(this.dialog, { ...dialog }, { ...resData.dialog })
                Object.assign(this.popDialogData, { ...resData })
                Object.assign(this, { clickTarget })
            }
        }
    },
    methods: {
        
        
        
        btnSelectedShit() {
            return this.shit$(`bgc:rgba(14, 211, 255, 0.6)!; font-w:500; cursor:p!; c:#fff;`);
        },
        assembleCommonBtnShit() {
            return this.shit$(`w:160px; h:48px; radius:32.5px; text-a:c; lh:48px;`) + this.assembleCommonActiveShit()
        },
        assembleCommonActiveShit() {
            return this.shit$(`active:opacity:.6;`);
        },
    },
}
</script>
